export class AuthLoginResponse {
  resultCode!:number
}
